export * from "./types";
export { BRANDS } from "./brands";

import { BRANDS } from "./brands";
import { Brand, BrandKey, Product } from "./types";

/**
 * The brand used when none is configured. Preserves current production behavior
 * (the app shipped as TeleHeadache before brand selection existed).
 */
export const DEFAULT_BRAND_KEY: BrandKey = "th";

const VALID_KEYS = Object.keys(BRANDS) as BrandKey[];

export function isBrandKey(value: unknown): value is BrandKey {
  return typeof value === "string" && VALID_KEYS.includes(value as BrandKey);
}

/**
 * Resolve a brand by key, falling back to {@link DEFAULT_BRAND_KEY} for any
 * missing or unrecognized value.
 */
export function getBrand(key?: string | null): Brand {
  return BRANDS[isBrandKey(key) ? key : DEFAULT_BRAND_KEY];
}

/** Does this brand key belong to the given product? Unknown keys resolve as {@link getBrand} does. */
export function isProduct(key: string | null | undefined, product: Product): boolean {
  return getBrand(key).product === product;
}
